import { API } from "apis";
import TopHeader from "components/top/TopHeader";
import { ContextModel, PreAccessTokenModel } from "models";
import qs from "query-string";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useOutletContext } from "react-router-dom";
import { Utils } from "utils";

const ExistingClientsPage: React.FC = () => {
  const location = useLocation();
  const query = qs.parse(location.search);
  const pre_entry_id = (query.pre_entry_id as string) ?? "";

  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [data, setData] = React.useState<PreAccessTokenModel>();

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(false);
      try {
        const response = await API.Auth.preAccessTokenCheck(pre_entry_id);
        console.log(response);
        setData(response.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return <></>;
  }

  return (
    <div>
      <Helmet>
        <title>{data.invite_corp.is_existing ? '既存取引先' : '新規取引先'}</title>
      </Helmet>
      <TopHeader />
      <div className="w-full mx-auto py-8 px-16" style={{ maxWidth: "1920px" }}>
        <div className="font-bold text-2xl border-b">{data.invite_corp.is_existing ? '既存取引先' : '新規取引先'}</div>
        <div className="mx-4 my-8">
          下記の取引を行っている会社からTrust Linkageへ招待されました。
        </div>

        <div className="border border-black p-8 grid grid-cols-12 gap-y-8">
          <div className="col-span-3">取引先</div>
          <div className="col-span-9 font-bold">
            {data.invite_corp_name || ''}
          </div>
          <div className="col-span-3">月間取引高</div>
          <div className="col-span-9 font-bold">
            {Utils.addComma(data.invite_corp.trading_voleme_per_month, false) || '0'}円
          </div>
        </div>

        <div className="flex justify-center m-8">
          <Link to={`/company-entry-apply/?pre_entry_id=${pre_entry_id}`}>
            <button className="primary px-4 py-2">会社登録</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExistingClientsPage;
